"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperSubscriptions.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _log = require('shared/log');


var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _untypedAlert = require('web/screens/Super/untypedAlert');

var _formHelpers = require('web/screens/Super/formHelpers');

// These modals stay mounted while the org screen shows a subscription, so
// state seeded from props at mount is kept across open and close, as the
// classes' constructors did.










 const SuperUpdateSubscriptionModal = ({
  subscription, open, onClose, onSubmit,
}) => {
  const [customerID, setCustomerID] = _react.useState.call(void 0, subscription.StripeCustomerID)
  const [subscriptionID, setSubscriptionID] = _react.useState.call(void 0, subscription.StripeSubscriptionID)

  const canSend = !!(customerID && subscriptionID)

  const submit = () => {
    onSubmit(subscription.SubscriptionKey, customerID, subscriptionID)
  }

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: onClose,
      title: "Update Stripe Details"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}

      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "Add a new subscription to an organization"      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Stripe Customer ID"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        , _react2.default.createElement(_Form.TextInput, {
          placeholder: "cus_IXGjlZfsRPyLt7",
          value: customerID,
          onChange: e => setCustomerID(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        )
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Stripe Subscription ID"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        , _react2.default.createElement(_Form.TextInput, {
          placeholder: "sub_IXGj7sbqEOSYSJ",
          value: subscriptionID,
          onChange: e => setSubscriptionID(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        primaryBtnLabel: "Submit",
        isPrimaryEnabled: canSend,
        onPrimaryBtnClick: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
      )
    )
  )
}; exports.SuperUpdateSubscriptionModal = SuperUpdateSubscriptionModal








 const SuperAttachOrgToOtherSubscriptionModal = ({
  currentOrgKey, open, onClose, onSubmit,
}) => {
  // Never reset on close, as in the class; only the confirm step resets.
  const [newOrgOwnerKey, setNewOrgOwnerKey] = _react.useState.call(void 0, '')
  // Both orgs, once the lookup has found them; the confirm step shows them.
  const [lookup, setLookup] = _react.useState(null)
  const [lookupError, setLookupError] = _react.useState(null)

  const resetState = () => {
    setLookup(null)
    setLookupError(null)
  }

  // componentDidUpdate, which ran before paint: reset the confirm step when
  // the modal closes.
  const prevOpen = _react.useRef.call(void 0, open)
  _react.useLayoutEffect.call(void 0, () => {
    if (prevOpen.current && !open) {
      resetState()
    }
    prevOpen.current = open
  }, [open])

  const ownerKey = newOrgOwnerKey.trim()
  // SuperAttachOrgToExistingSubscription requires `validate:"uuid4"` keys.
  const canSend = _formHelpers.isUuid4.call(void 0, ownerKey)
  // The backend's uuid4 check rejects uppercase letters, so a pasted
  // uppercase key would leave Submit disabled with no reason given.
  const caseHint = !canSend && _formHelpers.isUuid4.call(void 0, ownerKey.toLowerCase())
    ? 'Org keys are lowercase. Change the letters in the key to lowercase.'
    : undefined

  const submit = () => {
    if (!canSend) return
    // SAFETY: checked above to be a key.
    const owner = ownerKey 
    setLookupError(null)
    _actions2.default.getOrgs({ OrgKeys: [owner, currentOrgKey] })
      .then(res => {
        const from = _optionalChain([res, 'access', _ => _.Orgs, 'optionalAccess', _2 => _2[currentOrgKey]])
        const to = _optionalChain([res, 'access', _3 => _3.Orgs, 'optionalAccess', _4 => _4[owner]])
        if (!from || !to) {
          setLookupError(`Org not found: ${to ? currentOrgKey : owner}`)
          return
        }
        // Confirms the key that was looked up, even if the field changed meanwhile.
        setLookup({ ownerKey: owner, from, to })
      })
      .catch(err => {
        _log.log.info(err)
        _untypedAlert.pushUntypedAlert.call(void 0, "Failure", "Something went wrong while retrieving orgs. Check the console.")
        resetState()
      })
  }

  const confirm = () => {
    if (lookup) onSubmit(currentOrgKey, lookup.ownerKey)
  }

  const formContent = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "OrgOwnerKey of subscription"  , errorMessage: _nullishCoalesce(lookupError, () => ( caseHint)), __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
        , _react2.default.createElement(_Form.TextInput, {
          placeholder: "7821f54a-4a5b-4b6e-9c36-e75c0b6fc8e2",
          value: newOrgOwnerKey,
          onChange: e => setNewOrgOwnerKey(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Submit",
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        onPrimaryBtnClick: submit,
        isPrimaryEnabled: canSend, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
      )
    )
  )

  const confirmMoveDialog = lookup && (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}, "Are you sure you want to attach this org"
                , ' '
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}, lookup.from.Name), ' ', "to the subscription owned by this org"
              , ' '
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}, lookup.to.Name), "?"
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        primaryBtnLabel: "Confirm",
        onPrimaryBtnClick: confirm, __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}
      )
    )
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: onClose,
      title: "Move Org to another subscription"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}

      ,  confirmMoveDialog || formContent 
    )
  )
}; exports.SuperAttachOrgToOtherSubscriptionModal = SuperAttachOrgToOtherSubscriptionModal








 const SuperSubscriptionOverageExemptModal = ({
  subscription, open, onClose, onSubmit,
}) => {
  const [overageExempt, setOverageExempt] = _react.useState.call(void 0, !!subscription.OverageExempt)

  const submit = () => {
    onSubmit(subscription.SubscriptionKey, overageExempt)
  }

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: onClose,
      title: "SMS Overage Exemption"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}

      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}, "Exempt subscriptions are never charged for SMS overage at renewal. Usage is still counted and shown on the Plan tab. Use this for legacy and enterprise accounts with negotiated pricing."



      )
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}
        , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
          , _react2.default.createElement('input', {
            type: "checkbox",
            name: "Overage Exempt" ,
            id: "overageExempt",
            onChange: (e) => { setOverageExempt(e.target.checked) },
            checked: overageExempt, __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}
          ), " Exempt from SMS overage billing"

        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        primaryBtnLabel: "Submit",
        onPrimaryBtnClick: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 222}}
      )
    )
  )
}; exports.SuperSubscriptionOverageExemptModal = SuperSubscriptionOverageExemptModal









 const SuperUpdateSubscriptionOrgSettingsModal = ({
  orgKey, subscription, open, onClose, onSubmit,
}) => {
  // SAFETY: the org screen loads the subscription by this org, so its
  // settings are present; a missing entry throws here, as the class did.
  const initialSetting = subscription.SubscriptionOrgSettings[orgKey] 
  const [bloomTextPro, setBloomTextPro] = _react.useState.call(void 0, initialSetting.BloomTextProfessional)
  const [patientMessaging, setPatientMessaging] = _react.useState.call(void 0, initialSetting.PatientMessaging)

  const submit = () => {
    const subscriptionKey = subscription.SubscriptionKey
    onSubmit(subscriptionKey, orgKey, bloomTextPro, patientMessaging)
  }

  // SAFETY: as above; the class read the name from the current subscription on every render.
  const orgName = (subscription.SubscriptionOrgSettings[orgKey] ).Name

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: onClose,
      title: "Update Subscription Org Settings"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}

      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 263}}, "Update subscription settings for "    ,  orgName )
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
        , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
          , _react2.default.createElement('input', {
            type: "checkbox",
            name: "BloomText Professional" ,
            id: "bloomTextPro",
            onChange: (e) => { setBloomTextPro(e.target.checked) },
            checked: bloomTextPro, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
          ), " BloomText Professional"

        )
      )
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
        , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}
          , _react2.default.createElement('input', {
            type: "checkbox",
            name: "SMS Messaging" ,
            id: "patientMessaging",
            onChange: (e) => { setPatientMessaging(e.target.checked) },
            checked: patientMessaging, __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}}
          ), " SMS Messaging"

        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        primaryBtnLabel: "Submit",
        onPrimaryBtnClick: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}}
      )
    )
  )
}; exports.SuperUpdateSubscriptionOrgSettingsModal = SuperUpdateSubscriptionOrgSettingsModal
